<h2 lvrPadding [padHorizontal]="32" [padVertical]="0">
	{{ titleKey() | transloco }}
</h2>

<div style="margin-bottom: 16px">
	<p style="max-width: 600px">
		{{ infoKey() | transloco }}
	</p>
</div>

<lvr-fds-assignment-details [isSubmitView]="true"></lvr-fds-assignment-details>

<lvr-assignment-links
	[clientId]="clientId()"
	[assignmentId]="assignment()!.id"
	[redirectUrl]="currentUrl"
	[isServiceOfficeStatementSubmitView]="true"
></lvr-assignment-links>

<lvr-assignment-checks
	[errors]="validationData()!"
	[assignmentId]="assignment()!.id"
	[clientId]="clientId()"
	[isServiceOfficeStatement]="true"
	[reportId]="fdsReport()?.id"
	[targetPhase]="targetPhase()"
></lvr-assignment-checks>

<lvr-default-actions
	[showLoading]="saving()"
	[labelSave]="actionKey()"
	(save)="save()"
	[disableSave]="disableContinueButton()"
	(cancelSave)="cancel()"
></lvr-default-actions>
